var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isActiveStep(_vm.step)
    ? _c("StepWrapper", { attrs: { step: _vm.step } }, [
        _c(
          "div",
          { staticClass: "solutionguide__grid" },
          _vm._l(_vm.application.components, function (component) {
            return _c(
              "div",
              {
                staticClass: "solutionguide__grid-item",
                on: { click: () => _vm.selectComponent(component) },
              },
              [
                _c("button", { staticClass: "button" }, [
                  _c("img", {
                    staticClass: "solutionguide__grid-icon",
                    attrs: {
                      src: component.icon,
                      alt: component.name,
                      width: "100",
                      height: "100",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "solutionguide__grid-label" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(component.name) +
                      "\n            "
                  ),
                ]),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button-wrapper" },
          [
            _c(
              "GlobalButton",
              { attrs: { theme: "secondary" }, on: { click: _vm.back } },
              [_vm._v(_vm._s(_vm.$t("component.button.back")))]
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }